<template>
    <section id="section" class="cb">
        <div>
            <div class="video-container cp" @contextmenu.prevent>
                <!--<video-player :style="playerOptions.sources[0].src ? 'visibility: visible' : 'visibility: hidden'" @ready="playerReadied" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions" @error="error"></video-player>-->
                <iframe v-if="bili" id="video-iframe" :src="`//player.bilibili.com/player.html?bvid=${bili}&page=1&autoplay=0&danmaku=1&muted=0`" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe>
                <base-player v-else-if="playerOptions.sources[0].src" :options="playerOptions"></base-player>
            </div>

            <div class="left-container fl">
                <div class="video-about cb">
                    <div class="va-main">
                        <h1 class="video-title">{{title}}</h1>

                        <div class="video-meta">
                            {{$view(views)}}播放 · {{$time(addtime)}}
                        </div>
                    </div>

                    <div class="video-menu df">
                        <div class="video-menu-action">
                            <div @click="likeVideo" :class="`df${is_like ? ' action-active' : ''}`" :title="`点赞数${likes}`">
                                <div v-waves.circle="100">
                                    <i :class="is_like ? 'icon-liked' : 'icon-like'"></i>
                                </div>
                                <span class="video-menu-count">{{likes || '赞'}}</span>
                            </div>
                        </div>
                        <div class="video-menu-action">
                            <div @click="collectVideo" :class="`df${is_collect ? ' action-active' : ''}`" :title="`收藏数${collects}`">
                                <div v-waves.circle="100">
                                    <i :class="is_collect ? 'icon-collected' : 'icon-collect'"></i>
                                </div>
                                <span class="video-menu-count"> {{collects || '收藏'}}</span>
                            </div>
                        </div>

                    </div>

                    <div class="video-about-box cb" v-if="dancers.length || studio.id || owner.id">
                        <div class="video-about-item fl" v-if="dancers.length">
                            <div class="video-about-title">相关舞者</div>
                            <div v-for="v in dancers" :key="v.id" class="video-about-dancer fl">
                                <!--<router-link class="dancer-thumb-link" :to="`/dancer/${v.id}`"><img class="dancer-thumb" :src="v.thumb"></router-link>-->
                                <a class="dancer-thumb-link" :href="`/dancers/${v.id}`" target="_blank"><img class="dancer-thumb" :src="v.thumb" alt=""></a>
                                <div class="fl">
                                    <router-link class="dancer-link" :to="`/dancers/${v.id}`">{{v.name}}</router-link>
                                    <p>{{v.tip}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="video-about-item fl" v-if="studio.id">
                            <div class="video-about-title">相关工作室</div>
                            <!--<router-link class="dancer-thumb-link" :to="`/studio/${studio.id}`"><img class="dancer-thumb" :src="studio.thumb"></router-link>-->
                            <a class="dancer-thumb-link" :href="`/studios/${studio.id}`" target="_blank"><img class="dancer-thumb" :src="studio.thumb" alt=""></a>
                            <!--<a class="dancer-thumb-link" href="javascript:;"><img class="dancer-thumb" :src="studio_thumb"></a>-->
                            <div class="fl">
                                <!--<router-link class="dancer-link" :to="`/studio/${studio.id}`">{{studio.name}}</router-link>-->
                                <a class="dancer-link" :href="`/studios/${studio.id}`" target="_blank">{{studio.name}}</a>
                                <!--<a class="dancer-link" href="javascript:;">{{studio.name}}</a>-->
                                <p>{{studio.tip}}</p>
                            </div>
                        </div>

                        <div class="video-about-item fl" v-if="owner.id">
                            <div class="video-about-title">投稿作者</div>
                            <a :href="`/spaces/${owner.id}`" class="dancer-thumb-link" target="_blank"><img class="dancer-thumb" :src="owner.thumb" alt=""></a>
                            <div class="fl dancer-info">
                                <a :href="`/spaces/${owner.id}`" class="dancer-link" target="_blank">{{owner.name}}</a>
                                <p>{{owner.sign || '这位用户很神秘，啥都没写（/TДT)/'}}</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="comment-container">
                    <div class="comment-title-container">
                        <span class="comment-title">{{comments ? `${comments + replies}条评论` : '暂时没有评论, 快来抢沙发吧(～￣▽￣)～ '}}</span>
                        <div class="fr" v-show="comments">
                            <a @click="desc" :class="`comment-order${is_desc ? ' comment-order-active' : ''}`">按时间倒序</a>
                            <a @click="asc" :class="`comment-order${is_desc ? '' : ' comment-order-active'}`">按时间正序</a>
                        </div>
                    </div>
<!--                    <div class="comment-editor-container pr" @keydown.ctrl.enter="sendComment">-->
<!--                        <div class="comment-baffle" v-if="!uid">-->
<!--                            请先 <span class="sign-btn" @click="sign.sign_box_show = true">登录</span> 后再发表评论-->
<!--                        </div>-->
<!--                        <div class="comment-baffle" v-if="uid && !user.phone">-->
<!--                            请先 <span class="sign-btn" @click="sign.phone_box_show = true">绑定手机</span> 后再发表评论-->
<!--                        </div>-->
<!--                        <textarea v-model="content" class="comment-editor" placeholder="写下你的评论..."></textarea>-->
<!--                        <div class="comment-editor-tool">-->
<!--                            <span class="fl icon-emoji"></span>-->
<!--                            <span class="fl comment-tips">Ctrl+Enter 发表</span>-->
<!--                            <span @click="sendComment" class="fr comment-send" v-if="uid && user.phone">-->
<!--                            <span v-show="!is_comment_sending">发表评论</span>-->
<!--                            <span v-show="is_comment_sending" class="comment-send-loading"></span>-->
<!--                        </span>-->
<!--                            <span class="fr comment-send disabled" v-if="!uid || !user.phone">-->
<!--                            <span v-show="!is_comment_sending">发表评论</span>-->
<!--                            <span v-show="is_comment_sending" class="comment-send-loading"></span>-->
<!--                        </span>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="comment-editor-container pr">
                        <base-area
                            @send="sendComment"
                            v-model="content"
                            button-name="发表评论"
                            button-width="100px"
                            button-height="38px"
                            area-height="80px"
                            area-padding="10px 15px"
                        >
                        </base-area>
                    </div>

                    <div class="comment-list-container">
                        <div class="comment-content-container" v-for="(v, k) in commentLists" :key="v.id">
                            <div class="comment-author">
                                <a :href="`/spaces/${v.user_id}`" class="comment-author-thumb" target="_blank">
                                    <img v-lazy="{src: v.thumb ? v.thumb.replace(/http:/, '') : 'https://img.vhiphop.top/icon/a.png', error: 'https://img.vhiphop.top/icon/a.png', loading: 'https://img.vhiphop.top/icon/a.png'}" alt="">
                                </a>
                                <div class="comment-author-info">
                                    <!--<router-link class="comment-author-nico" to="/user/">{{v.nico}}</router-link>-->
                                    <a :href="`/spaces/${v.user_id}`" class="comment-author-nico" target="_blank">{{v.nico}}</a>
                                    <div class="comment-author-time">{{comments - k}}楼 · {{$time(v.addtime)}}</div>
                                </div>
                            </div>
                            <p class="comment-content">{{v.content}}</p>
                            <div class="comment-tool">
                                <div @click="likeComment(v, 1)" class="comment-tool-action">
                                    <div v-waves.circle="100">
                                        <i :class="`icon-zan${v.is_like ? '-fill' : ''}`"></i>
                                    </div>
                                    <i class="comment-tool-text">{{v.likes ? v.likes : ''}}</i>
                                </div>
                                <span class="comment-tool-action" @click="showEditor(k, v.id, v.user_id)">
                                <span class="icon-comment"></span>
                                <span class="comment-tool-text">回复</span>
                            </span>
                            </div>
                            <div class="comment-reply-list" v-show="v.children" :ref="`reply-box-${k}`" :has-reply="v.children ? 1 : ''">
                                <div class="comment-reply-container" v-for="vv in v.children" :key="vv.id">
                                    <a :href="`/spaces/${vv.user_id}`" target="_blank">
                                        <img v-lazy="{src: vv.thumb ? vv.thumb.replace(/http:/, '') : 'https://img.vhiphop.top/icon/a.png', error: 'https://img.vhiphop.top/icon/a.png', loading: 'https://img.vhiphop.top/icon/a.png'}" class="comment-reply-thumb" alt="">
                                    </a>

                                    <div class="comment-reply-box">
                                        <div class="comment-reply"><a :href="`/spaces/${vv.user_id}`" class="comment-reply-author" target="_blank">{{vv.nico}}</a>：<span v-if="!vv.is_direct"><a class="comment-reply-author" :href="`/spaces/${vv.pid}`" target="_blank">回复 @{{vv.p_nico}} </a>：</span>{{vv.content}}</div>

                                        <div class="comment-tool">
                                            <span class="comment-tool-action">{{vv.addtime.substr(0, 16)}}</span>
                                            <div @click="likeComment(vv, 0)" class="comment-tool-action">
                                                <div v-waves.circle="100">
                                                    <span :class="`icon-zan${vv.is_like ? '-fill' : ''}`"></span>
                                                </div>

                                                <span class="comment-tool-text">{{vv.likes ? vv.likes : ''}}</span>
                                            </div>
                                            <span class="comment-tool-action" @click="showEditor(k, v.id, vv.user_id, vv.id, vv.nico)">
                                            <span class="icon-comment"></span>
                                            <span class="comment-tool-text">回复</span>
                                        </span>

                                        </div>
                                    </div>

                                </div>

                                <div class="comment-sub-reply" v-if="v.children" @click="showEditor(k, v.id, v.user_id)">
                                    <span class="icon-reply"></span>
                                    添加新评论
                                </div>
<!--                                <base-area-->
<!--                                    v-show="false"-->
<!--                                    v-model="content"-->
<!--                                    :show-cancel-button="true"-->
<!--                                    button-name="发表评论"-->
<!--                                    button-width="100px"-->
<!--                                    button-height="38px"-->
<!--                                    @send="sendReply(k)"-->
<!--                                    @cancel="hideEditor(k)"-->
<!--                                    :ref="`editor-${k}`"-->
<!--                                    class="comment-editor-container pr"-->
<!--                                >-->
<!--                                </base-area>-->
                                <div class="comment-editor-container pr" style="display: none" :ref="`editor-box-${k}`" @keydown.ctrl.enter="sendReply(k)">
                                    <div class="comment-baffle" v-if="!uid">
                                        请先 <span class="sign-btn" @click="sign.sign_box_show = true">登录</span> 后再发表评论
                                    </div>
                                    <div class="comment-baffle" v-if="uid && !user.phone">
                                        请先 <span class="sign-btn" @click="sign.phone_box_show = true">绑定手机</span> 后再发表评论
                                    </div>
                                    <textarea v-model="contents[k]" class="comment-editor" placeholder="写下你的评论..." :ref="`editor-${k}`"></textarea>
                                    <div class="comment-editor-tool">
<!--                                        <span class="fl icon-emoji"></span>-->
<!--                                        <span class="fl comment-tips">Ctrl+Enter 发表</span>-->
                                        <span v-if="uid && user.phone" @click="sendReply(k)" :ref="`editor-send-${k}`" class="fr comment-send">
                                        <span v-show="!is_comment_sending">发表评论</span>
                                        <span v-show="is_comment_sending" class="comment-send-loading"></span>
                                    </span>

                                        <span v-if="!uid || !user.phone" :ref="`editor-send-${k}`" class="fr comment-send disabled">
                                        <span v-show="!is_comment_sending">发表评论</span>
                                        <span v-show="is_comment_sending" class="comment-send-loading"></span>
                                    </span>
                                        <span class="fr comment-cancel" @click="hideEditor(k)">取消</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <el-pagination
                        v-if="comments > 20"
                        background
                        layout="total, prev, pager, next"
                        :current-page="page"
                        :page-size="20"
                        :total="comments"
                        @current-change="currentChange"
                        class="pagenavi"
                    />
                </div>
            </div>

            <aside class="right-container fr" v-if="recoVideos.length">
                <h3 class="reco-title">相关推荐</h3>
                <ul>
                    <li class="reco-video-list" v-for="v in recoVideos" :key="v.id">
                        <router-link :to="{name: 'video', params: {id: v.id, src: v.src}}" class="reco-video-thumb-box fl cb">
                            <i class="icon-play"></i>
                            <img class="reco-video-thumb" v-lazy="v.thumb" alt="">
                            <div class="video-mask"></div>
                        </router-link>

                        <div class="reco-video-info">
                            <router-link class="reco-video-link" :to="{name: 'video', params: {id: v.id, src: v.src}}" :title="v.title">{{v.title}}</router-link>
                            <p class="reco-video-count reco-video-cate ellipsis" :title="`舞蹈风格: ${v.cate}`">{{v.cate}}</p>
                            <span class="reco-video-count">
                            <!--<i class="icon-play"></i>-->
                            {{$view(v.views)}}播放
                        </span>
                        </div>
                    </li>
                </ul>
            </aside>
        </div>
        <base-not-found v-if="!isLoading && !isUpdating && !playerOptions.sources[0].src && !bili"></base-not-found>
    </section>
</template>

<script>
    export default {
        data: () => ({
            isLoading: true,
            isUpdating: false,
            playerOptions : {
                autoplay: true, //如果true,浏览器准备好时开始播放。
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                sources: [{
                    type: '',
                    src: '' //url地址
                }],
            },
            title: '',
            addtime: '',
            views: 0,
            likes: 0,
            collects: 0,
            comments: 0,
            shares: 0,
            commentLists: [],
            reply_count: 0,
            is_desc: true,
            is_getting: false,
            page: 1,
            is_collect: false,
            is_like: false,
            link: '',
            src: '',
            bili: '',
            studio: {
                id: 0,
                name: '',
                thumb: '',
                tip: '',
            },
            owner: {
                id: 0,
                name: '',
                thumb: '',
                sign: '',
            },
            user_id: 0,
            user_nico: '',
            user_thumb: '',
            not_direct: [],
            content: '',
            contents: [],
            tid: 0,
            pid: 0,
            is_direct: false,
            p_content_id: 0,
            p_nico: '',
            dancers: [],
            recoVideos: [],
            is_comment_sending: false,
            is_collecting: false,
            is_liking: false,
        }),
        computed: {
            state() {
                return this.$store.state;
            },
            user() {
                return this.state.user;
            },
            uid() {
                return this.user.id;
            },
            video() {
                return this.state.video;
            },
            sign() {
                return this.state.sign;
            },
            id() {
                return this.$route.params.id;
            }
        },
        watch: {
            uid() {// 登录退出 刷新状态
                let {api, id} = this;
                api.get(`videos/${id}/likes`).then(e => this.is_like = !!e, () => {});
                api.get(`videos/${id}/collect`).then(e => this.is_collect = !!e, () => {});
            }
        },
        methods: {
            currentChange(e) {
                this.api.get(`videos/${this.id}/comments`, {
                    is_asc: +!this.is_desc,
                    page: e
                }).then(e => {
                    this.commentLists = e;
                })
            },
            // 正序排列评论
            asc() {
                if (!this.is_desc || this.is_getting) return;

                this.is_desc = false;
                this.is_getting = true;

                this.api.get(`videos/${this.id}/comments`, {is_asc: 1}).then(e => {
                    this.commentLists = e;
                    this.is_getting = false;
                }, () => {
                    this.is_getting = false;
                })
            },
            // 倒序排列评论
            desc() {
                if (this.is_desc || this.is_getting) return;

                this.is_desc = true;
                this.is_getting = true;

                this.api.get(`videos/${this.id}/comments`).then(e => {
                    this.commentLists = e;
                    this.is_getting = false;
                }, () => {
                    this.is_getting = false;
                })
            },
            playerReadied(e) {
                e.volume(this.video.volume);
                e.on('volumechange', () => {
                    this.video.volume = e.volume();
                    window.localStorage.volume = e.volume();
                });
            },
            showEditor(k, tid, pid, id, nico) {// 显示回复框, 并
                let [replyBox, editorBox, editor] = [
                    this.$refs[`reply-box-${k}`][0],
                    this.$refs[`editor-box-${k}`][0].style,
                    this.$refs[`editor-${k}`][0],
                ];

                this.tid = tid;
                this.pid = pid || 0;
                this.p_nico = nico || '';
                this.p_content_id = id || 0;// 父级评论id

                editor.value = '';// 清空回复框内容
                if (id) {// 非直接回复顶级评论
                    editor.setAttribute('placeholder', `回复 @${nico} :`);
                    editorBox.display = 'block';
                    this.not_direct[k] = true;// 声明为非直接回复
                    this.is_direct = false;
                } else {// 直接回复顶级评论
                    this.is_direct = true;
                    if (this.not_direct[k]) {// 如果上次的状态不是直接回复顶级评论 则只需要清空placeholder
                        editor.setAttribute('placeholder', '写下你的评论');
                        this.not_direct[k] = false;// 声明为直接回复
                    } else {// 否则进行toggle切换
                        editorBox.display = editorBox.display === 'none' ? 'block' : 'none';// 编辑器容器toggle
                        if (!replyBox.getAttribute('has-reply')) replyBox.style.display = editorBox.display;// 只有当 有回复楼层的时候 才会使父级一起toggle
                    }
                }
                editor.focus();// 回复框聚焦 (必须是显示的元素才能聚焦)
            },
            hideEditor(k) {// 取消回复
                let replyBox = this.$refs[`reply-box-${k}`][0];
                this.not_direct[k] = false;// 声明为直接回复
                this.$refs[`editor-${k}`][0].setAttribute('placeholder', '写下你的评论');// 清空placeholder
                this.$refs[`editor-box-${k}`][0].style.display = 'none';// 编辑器容器隐藏
                if (!replyBox.getAttribute('has-reply')) replyBox.style.display = 'none';// 只有当 有回复楼层的时候 才会使父级一起隐藏
            },
            likeVideo() {// 点赞视频
                if (this.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                let {api, id} = this;
                this.is_liking = true;

                if (this.is_like) {
                    this.is_like = false;
                    this.likes--;

                    api.get(`videos/${id}/likes/del`).then(() => {
                        this.is_liking = false;
                    }, e => {
                        this.likes++;
                        this.is_liking = false;
                        this.alert.err(e.message);
                    })
                } else {
                    this.is_like = true;
                    this.likes++;

                    api.post(`videos/${id}/likes`).then(() => {
                        this.is_liking = false;
                    }, e => {
                        this.likes--;
                        this.is_like = this.is_liking = false;
                        this.alert.err(e.message);
                    })
                }

            },
            collectVideo() {// 收藏视频
                if (!this.uid) return this.sign.sign_box_show = true;
                if (this.is_collecting) return;

                let {api, id} = this;
                this.is_collecting = true;

                if (this.is_collect) {
                    this.collects--;
                    this.is_collect = false;

                    api.del(`videos/${id}/collect`).then(() => {
                        this.is_collecting = false;
                    }, e => {
                        this.collects++;
                        this.is_collect = true;
                        this.is_collecting = false;
                        this.alert.err(e.message);
                    })
                } else {
                    this.is_collect = true;
                    this.collects++;
                    api.post(`videos/${id}/collect`).then(() => {
                        this.is_collecting = false;
                    }, e => {
                        this.is_collect = false;
                        this.collects--;
                        this.is_collecting = false;
                        this.alert.err(e.message);
                    })
                }

            },
            sendComment() {// 发布顶级评论
                let { content } = this;

                if (this.is_comment_sending) return false;

                if (!content) {
                    return this.alert.err('请发送 1 到 1000 字的评论');
                }

                this.is_comment_sending = true;

                this.api.post(`videos/${this.id}/comments`, { content, is_direct: 1 }).then(e => {

                    let {user} = this;

                    this.commentLists.unshift({
                        id: e.id,
                        addtime: e.addtime,
                        content,
                        user_id: user.id,
                        thumb: user.thumb,
                        nico: user.nico,
                        is_like: false,
                        likes: 0,
                        children: [],
                    });
                    if (this.commentLists.length === 21) {
                        this.comments.pop();
                    }
                    this.content = '';
                    this.comments++;
                    this.is_comment_sending = false;

                }, () => {
                    this.is_comment_sending = false;
                })
            },
            sendReply(k) {// 发布回复评论
                let { contents, tid, pid, p_nico, is_direct, p_content_id } = this, content;

                if (this.is_comment_sending) return false;

                if (!contents[k]) return this.alert.err('请发送1到1000字的评论');

                content = contents[k];

                this.is_comment_sending = true;

                this.api.post(`videos/${this.id}/comments`, {content, tid, pid, is_direct: +is_direct, p_content_id}).then(e => {
                    let {user} = this;

                    this.commentLists[k].children.unshift({
                        id: e.id,
                        addtime: e.addtime,
                        content,
                        thumb: user.thumb,
                        user_id: user.id,
                        nico: user.nico,
                        is_like: false,
                        likes: 0,
                        pid,
                        p_nico,
                        is_direct,
                    });
                    this.contents[k] = '';
                    this.replies++;
                    this.is_comment_sending = false;
                }, () => {
                    this.is_comment_sending = false;
                })
            },
            likeComment(v, is_top) {
                if (!this.uid) return this.sign.sign_box_show = true;
                if (v.is_liking) return;
                v.is_liking = true;

                if (v.is_like) {
                    v.is_like = false;
                    v.likes--;
                    this.api.del(`videos/comments/${v.id}/likes`, {is_top}).then(() => {
                        v.is_liking = false;
                    }, e => {
                        this.alert.err(e.message);
                        v.likes++;
                        v.is_like = true;
                        v.is_liking = false;
                    });
                } else {
                    v.is_like = true;
                    v.likes++;
                    this.api.post(`videos/comments/${v.id}/likes`, {is_top}).then(() => {
                        v.is_liking = false;
                    }, e => {
                        this.alert.err(e.message);
                        v.likes--;
                        v.is_like = v.is_liking = false;
                    });
                }
            },
            error(e) {// 如果视频下载出错 则初始化视频至已缓冲时间的前3秒
                let err = e.error();
                if (err.code === 2) {// 判断是否是网络加载问题
                    let buffTime = e.bufferedEnd() - 6;
                    e.load(this.playerOptions.sources[0].src);
                    e.currentTime(buffTime);
                    e.play();
                } else {
                    this.alert.err(err.message);
                }

            }
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            let {api} = this, {src, id} = to.params, host = `videos/${id}`;
            this.playerOptions.sources[0].src = src;

            this.isUpdating = true;
            api.get(host).then(e => {
                if (!e) return this.isUpdating = this.playerOptions.sources[0].src = false;
                /*let keys = Object.keys(e), l = keys.length;
                while (l--) this[keys[l]] = e[keys[l]];*/
                this.playerOptions.sources[0].src = e.src || '';
                this.bili = e.bili || '';
                this.title = e.title || '';
                this.addtime = e.addtime;
                this.views = e.views;
                this.likes = e.likes;
                this.collects = e.collects;
                this.comments = e.comments;
                this.replies = e.replies;
                this.shares = e.shares;
                this.is_like = e.is_like;
                this.is_collect = e.is_collect;
                if (e.user) this.owner = e.user;
                if (e.dancers) this.dancers = e.dancers;
                if (e.studio) this.studio = e.studio;
                this.isUpdating = false;
            }, this.err);

            api.get(`${host}/reco`).then(e => {
                this.recoVideos = e;
            });

            api.get(`${host}/comments`).then(e => {
                this.commentLists = e;
            });
            next();
        },
        beforeMount() {
            let {api, id} = this, {src} = this.$route.params, host = `videos/${id}`;
            this.$set(this.playerOptions.sources, 0, {
                type: 'video/mp4',
                src
            });

            api.get(host).then(e => {
                if (!e) return this.isLoading = false;

                if (!this.bili && e.src) this.$set(this.playerOptions.sources, 0, {
                    type: 'video/mp4',
                    src: e.src,
                });
                // console.log(this.playerOptions.sources);
                this.title = e.title || '';
                this.bili = e.bili || '';
                this.addtime = e.addtime;
                this.views = e.views;
                this.likes = e.likes;
                this.collects = e.collects;
                this.comments = e.comments;
                this.replies = e.replies;
                this.shares = e.shares;
                this.is_like = e.is_like;
                this.is_collect = e.is_collect;

                if (e.user) this.owner = e.user;
                if (e.dancers) this.dancers = e.dancers;
                if (e.studio) this.studio = e.studio;
                this.isLoading = false;
            }, this.err);

            api.get(`${host}/reco`).then(e => {
                this.recoVideos = e;
            });

            api.get(`${host}/comments`).then(e => {
                this.commentLists = e;
            });
        },
    }
</script>

<style scoped>
    @import "../../../static/css/views/video/detail.css";
</style>



// WEBPACK FOOTER //
// src/views/video/index.vue